export const ROLE = {
  SystemAdministrator: "SystemAdministrator",
  Employee: "Employee",
  Accountant: "Accountant",
  Manager: "Manager",
  AdministrativeAffairs: "İdari İşler",
  AdministrativeAffairsManager: "İdari İşler Yöneticisi",
};

// Masraf statüleri (backend: expense-status listesi ile birebir)
export const ExpenseStatus = {
  Onayda_Bekliyor: 1,
  Onaylandı: 2,
  Reddedildi: 3,
  Muhasebelestirildi: 4,
  Yeni_Onay_Sürecinde: 5,
  Taslak: 6,
  İptal_Edildi: 7,
};

// Avans statüleri (backend: advance-status listesi ile birebir)
export const AdvanceStatus = {
  Onayda: 1,
  Onaylandı: 2,
  Reddedildi: 3,
  Muhasebelestirildi: 4,
  Yeni_Onay_Sürecinde: 5,
  Taslak: 6,
};
